import { filter, lowerCase, orderBy } from 'lodash';
import { getDistance } from 'geolib';
import hospitals from '../components/Hospitals/hospitals.json';

export default (filterValue, { lat, lng }) => {
  const hospitalsWithDistance = [];
  hospitals.forEach(element => {
    element.distanceFromCurrentLocation = getDistance(
      { latitude: lat, longitude: lng },
      { latitude: element.location.lat, longitude: element.location.lng },
    );
    element.routeLink = `http://maps.google.com/?saddr=${lat},${lng}&daddr=${element.location.lat},${element.location.lng}`;
    hospitalsWithDistance.push(element);
  });

  const sortedHospitals = orderBy(hospitalsWithDistance, ['distanceFromCurrentLocation']);

  if (filterValue) {
    return filter(sortedHospitals, ({
      name,
      sector,
      address,
    }) => {
      return lowerCase(name).includes(lowerCase(filterValue))
      || lowerCase(sector).includes(lowerCase(filterValue))
      || lowerCase(address).includes(lowerCase(filterValue));
    });
  }

  return sortedHospitals;
};



// WEBPACK FOOTER //
// ./src/functions/getFilteredHospitals.js